import { Calendar, Image, Modal, Tag, Tooltip, message } from 'antd';
import { POSTTYPES } from '../../../../common/constants/postTypes';
import moment from 'moment';
import { CalendarOutlined, ClockCircleFilled, DeleteOutlined } from '@ant-design/icons';
import { ButtonLZ } from '../../design/Buttons/ButtonLZ';
import { useIsAuthorized } from '../../../pages/common/roles/Roles';
import { authFetch } from '../../../../common/request/authFetch';
import { useAuth } from '../../../../store/AuthContext/AuthContext';
import React from 'react';
import { CTA_TYPE } from '../../../../common/constants/postsConstants';
import { SummaryEdit } from '../../../pages/menuContents/posts/editFields/SummaryEdit';
import { Summary } from '../../../pages/menuContents/posts/editFields/Summary';

export const PostScheduled = (props: {postScheduled: any, onChange: any}) => {

	const isAuthorized = useIsAuthorized();
	const { projectGroup } = useAuth();

	const deleteScheduledPost = async() => {
		await authFetch(`${process.env.REACT_APP_API}/projects/${projectGroup.project}/${projectGroup.group}/postsScheduled/${props.postScheduled.id}` , { method: 'DELETE'})
		.then((res) => {
		  if (res) {
			  message.success('Programación eliminada correctamente', 3);
			  props.onChange();
		  } else {
			  message.error('Error inesperado al borrar la programación', 3);
		  }
		})
	  }

  	return (	
		<div style={{background:'white', padding:'25px', borderRadius: '10px'}}>
		<div style={{ display: 'flex', justifyContent:'space-between', marginBottom:'5px'}}>          
			<Tag style={{ borderRadius: '20px', marginBottom:'4px' }}>{POSTTYPES[props.postScheduled.post.type]}</Tag>
			{props.postScheduled.post?.callToActionType && 					
				<Tooltip title={props.postScheduled.post?.callToActionURL || (props.postScheduled.post?.callToActionURLLocal && <div>Se redirecciona a la URL que tengamos en la ficha como web</div>) }>
					<Tag color='geekblue' icon={React.createElement(CTA_TYPE[props.postScheduled.post?.callToActionType].icon)}>{CTA_TYPE[props.postScheduled.post?.callToActionType].name}</Tag>							
				</Tooltip>			                  
			} 
		</div>
		<div style={{display:'flex'}}>
			<div style={{display:'flex', width:'200px', height:'200px', alignItems:'center'}}>
				{
					props.postScheduled.post?.photosURL?.length > 0 ? 
					props.postScheduled.post.photosURL.map((googleUrl : string) => {
						return (<Image src={googleUrl} preview={true} style={{objectFit: 'contain', borderRadius:'10px'}}/>)
					})
					:
					<h2 style={{width:'200px', height:'200px', border:'.5px solid silver', margin:'0px', borderRadius: '20px', color:'silver', background:'GhostWhite', display:'flex', alignItems: 'center', justifyContent: 'center'}}>Sin foto</h2>
				}    
			</div>			
			<div style={{marginLeft:'10px', height:'300px', padding: '15px', textAlign:'justify', width:'100%', borderRadius:'10px', color:'rgba(0, 0, 0, 0.5)'}}>				
				<Summary postScheduled={props.postScheduled} onChange={() => {props.onChange()}}/>
			</div>
		</div>	  			          		
		
		<div style={{ display: 'flex', justifyContent:'flex-end', marginBottom:'5px'}}>          
          <ButtonLZ
		  	  type='link'
              disabled={!isAuthorized(['ROLE_ADMIN', 'ROLE_AGENT', 'ROLE_CLIENT', 'ROLE_MODULE_CONTENT'])}
              onClick={
                () => {
                  Modal.confirm({
                    title: '¿Confirma el borrado de esta programación?',
                    okText: 'Confirmar',
                    cancelText: 'Cancelar',
                    onOk() {
                      deleteScheduledPost()
                    }
                  });
                }
              }>
                <DeleteOutlined/> Eliminar programación
            </ButtonLZ>
          </div>		
		</div>
	)
}